export default __webpack_public_path__ + "static/media/tp-logo.be04e69f.png";